import { useContext } from "react";
import type { Socket } from "socket.io-client";
import { SocketContext } from "./socketContext";

export const useSocket = (): Socket | undefined => {
  return useContext(SocketContext);
};
